import React from 'react';

function DragHandle() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z" />
    </svg>
  );
}

export default DragHandle;



// WEBPACK FOOTER //
// ./src/common/icons/DragHandle.js